// extracted by mini-css-extract-plugin
module.exports = {"brandName":"SignUpForm_brandName__2yJdw","signUpArrow":"SignUpForm_signUpArrow__2V2no"};